import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DepartmentListModel } from "common/models/page-models/applicants/applicant-table/applicant-filter-data.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";

 
@Injectable()
export class DepartmentListRegisterDataService extends DataService<DepartmentListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getBranchForRegister,http);
    }
 

    createInstance(): DepartmentListModel {
        return new DepartmentListModel();
    }

    
 
}